import React from 'react';
import PriorityBadge from './PriorityBadge';
import { formatCurrency, formatScore } from '../lib/capacityPlanningFormatters';

const RecommendationDrawer = ({ item, open, onClose }) => {
  if (!open || !item) return null;

  return (
    <div className="fixed inset-0 z-[120] flex justify-end bg-black/50">
      <div className="h-full w-full max-w-xl overflow-y-auto border-l border-slate-800 bg-slate-950 p-5">
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            <h3 className="text-lg font-semibold text-slate-100">Detail Rekomendasi Ekspansi</h3>
            <p className="text-xs text-slate-500">{item.scopeType} • {item.scopeKey}</p>
          </div>
          <button type="button" onClick={onClose} className="rounded border border-slate-700 px-2 py-1 text-xs text-slate-200 hover:bg-slate-800">Tutup</button>
        </div>

        <div className="space-y-3">
          <div className="rounded-lg border border-slate-800 bg-slate-900/70 p-3">
            <div className="mb-2 flex items-center justify-between">
              <PriorityBadge priority={item.priorityClass} />
              <span className="text-xs text-slate-400">Urgensi {formatScore(item.urgencyScore)}</span>
            </div>
            <p className="text-sm font-semibold text-slate-100">{item.title}</p>
            <p className="mt-2 text-sm text-slate-300">{item.message}</p>
            <p className="mt-2 text-sm text-sky-300">{item.recommendedAction}</p>
          </div>

          <div className="grid grid-cols-2 gap-2 text-xs">
            <div className="rounded-md border border-slate-800 bg-slate-900/60 p-2">Demand: <span className="font-semibold text-slate-200">{formatScore(item.demandPressureScore)}</span></div>
            <div className="rounded-md border border-slate-800 bg-slate-900/60 p-2">Capacity: <span className="font-semibold text-slate-200">{formatScore(item.capacityPressureScore)}</span></div>
            <div className="rounded-md border border-slate-800 bg-slate-900/60 p-2">Risk: <span className="font-semibold text-slate-200">{formatScore(item.serviceRiskScore)}</span></div>
            <div className="rounded-md border border-slate-800 bg-slate-900/60 p-2">Revenue: <span className="font-semibold text-slate-200">{formatScore(item.revenueOpportunityScore)}</span></div>
            <div className="rounded-md border border-slate-800 bg-slate-900/60 p-2">Aktivasi Tertahan: <span className="font-semibold text-slate-200">{item.estimatedBlockedActivations || 0}</span></div>
            <div className="rounded-md border border-slate-800 bg-slate-900/60 p-2">Peluang: <span className="font-semibold text-emerald-300">{formatCurrency(item.estimatedRevenueOpportunity || 0)}</span></div>
          </div>

          <div className="rounded-lg border border-slate-800 bg-slate-900/60 p-3">
            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">Supporting Signals</p>
            <div className="space-y-1 text-xs text-slate-300">
              {(item.supportingSignals || []).map((sig, idx) => (
                <div key={`${sig.key}-${idx}`} className="flex items-start justify-between gap-2 border-b border-slate-800/70 py-1 last:border-b-0">
                  <span className="text-slate-400">{sig.key}</span>
                  <span className="text-right">{Array.isArray(sig.value) ? sig.value.join(', ') : String(sig.value)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendationDrawer;
